import React from "react";
import { PageHeader, DisclaimerFooter } from "@/components/Bits";
import { LOT_TABLE, fmtUSD } from "@/lib/calc";
import { Sunrise, Sun, Moon } from "lucide-react";

export default function Rules() {
  const rules = [
    ["RR", "1 : 1"],
    ["SL", "50 pips"],
    ["TP", "50 pips"],
    ["TURY", "Maks. 3 dziennie"],
    ["START", "$350"],
    ["CZAS", "92 dni"],
    ["CEL", "$200,000"],
  ];
  return (
    <div>
      <PageHeader title="Zasady challenge" subtitle="Dyscyplina ponad wszystko." />

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-10">
        {rules.map(([k, v]) => (
          <div key={k} className="glow-card rounded-xl p-5 text-center" data-testid={`rule-${k.toLowerCase()}`}>
            <div className="text-[10px] tracking-widest text-demon-muted">{k}</div>
            <div className="font-mono font-bold text-lg text-white mt-1">{v}</div>
          </div>
        ))}
      </div>

      <h2 className="font-display text-2xl font-bold mb-4">Trzy tury dziennie</h2>
      <div className="grid sm:grid-cols-3 gap-4 mb-10">
        {[
          { icon: Sunrise, t: "TURA 1 — RANO" },
          { icon: Sun, t: "TURA 2 — PO POŁUDNIU" },
          { icon: Moon, t: "TURA 3 — WIECZOREM" },
        ].map((c) => (
          <div key={c.t} className="glow-card rounded-xl p-6 flex items-center gap-4">
            <c.icon className="text-violet-400" size={28} />
            <div className="font-display font-semibold">{c.t}</div>
          </div>
        ))}
      </div>

      <h2 className="font-display text-2xl font-bold mb-4">Przelicznik lotów</h2>
      <div className="glow-card rounded-2xl overflow-x-auto mb-4">
        <table className="w-full text-sm font-mono min-w-[420px]">
          <thead className="bg-violet-950/40 text-demon-muted text-xs tracking-widest">
            <tr>
              <th className="text-left px-5 py-3">LOT</th>
              <th className="text-left px-5 py-3">50 PIPS TP</th>
              <th className="text-left px-5 py-3">50 PIPS SL</th>
            </tr>
          </thead>
          <tbody>
            {LOT_TABLE.map((r) => (
              <tr key={r.lot} className="border-t border-violet-900/20">
                <td className="px-5 py-2.5 text-white">{r.lot.toFixed(2)}</td>
                <td className="px-5 py-2.5 text-emerald-400">+{fmtUSD(r.tp, 0)}</td>
                <td className="px-5 py-2.5 text-red-400">-{fmtUSD(r.sl, 0)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="text-xs text-demon-muted/80">Założenie modelu: 0.10 lota = $50 przy ruchu 50 pips.</p>

      <div className="glow-card rounded-2xl p-6 mt-8">
        <h3 className="font-display font-semibold text-lg mb-2">Ważna logika</h3>
        <ul className="text-sm text-demon-muted space-y-2 list-disc pl-5">
          <li>Jeżeli nie wykonasz wszystkich 3 tur, nie jest to błąd — dzień otrzymuje status PARTIAL DAY.</li>
          <li>Jeżeli zrobisz stratę, system automatycznie przelicza aktualny kapitał.</li>
          <li>Nie wymuszaj „odrabiania” straty poprzez zwiększanie lota.</li>
        </ul>
      </div>

      <DisclaimerFooter />
    </div>
  );
}
